<div style="background-color: rgba(239,243,248,1);">
  <div class="taskbar" [ngClass]="{'collapse_sidebar':collapsed}" (mouseleave)="leaveSideBar($event)"  (mouseenter)="enterSideBar($event)">
    <div>
      <div id="Groupe_893" [ngStyle]="{ 'display': (collapsed_menu) ? 'none': 'block'}">
          <img src="../../../assets/img/geoprod-beta-version3.0-blanc.svg" alt="logo" />
      </div>
      <div (click)="toggleSideBar()" id="Groupe_704" [ngStyle]="{'left': (collapsed) ? '16px': '145px'}">
        <div id="Groupe_638">
          <svg class="Rectangle_157">
            <rect id="Rectangle_157" rx="7" ry="7" x="0" y="0" width="31" height="34">
            </rect>
          </svg>
          <div id="Groupe_637">
            <svg class="Rectangle_62">
              <rect id="Rectangle_62" rx="1.0396244525909424" ry="1.0396244525909424" x="0" y="0" width="18.297"
                    height="2.079">
              </rect>
            </svg>
            <svg class="Trac_943" viewBox="0 0 17.772 2.079">
              <path id="Trac_943"
                    d="M 1.211705446243286 0 L 16.55997276306152 0 C 17.22917938232422 0 17.77167892456055 0.4654556512832642 17.77167892456055 1.039624452590942 C 17.77167892456055 1.61379337310791 17.22917938232422 2.079248905181885 16.55997276306152 2.079248905181885 L 1.211705446243286 2.079248905181885 C 0.5424988865852356 2.079248905181885 0 1.61379337310791 0 1.039624452590942 C 0 0.4654556512832642 0.5424988865852356 0 1.211705446243286 0 Z">
              </path>
            </svg>
            <svg class="Rectangle_64">
              <rect id="Rectangle_64" rx="1.0396244525909424" ry="1.0396244525909424" x="0" y="0" width="12.475"
                    height="2.079">
              </rect>
            </svg>
          </div>
        </div>
      </div>
      <div class="logo_on_collapse" [ngStyle]="{'display': (collapsed) ? 'block': 'none'}">

        <svg _ngcontent-rkl-c19="" viewBox="902.358 2284.142 26.436 24.865" class="Trac_1112_umn">
          <linearGradient _ngcontent-rkl-c19="" id="Trac_1112_umn" spreadMethod="pad" x1="0" x2="1" y1="0.5" y2="0.5">
            <stop _ngcontent-rkl-c19="" offset="0" stop-color="#005c99" stop-opacity="1"></stop>
            <stop _ngcontent-rkl-c19="" offset="0.0106" stop-color="#005d9a" stop-opacity="1"></stop>
            <stop _ngcontent-rkl-c19="" offset="0.2972" stop-color="#007cbe" stop-opacity="1"></stop>
            <stop _ngcontent-rkl-c19="" offset="0.5662" stop-color="#0092d7" stop-opacity="1"></stop>
            <stop _ngcontent-rkl-c19="" offset="0.8083" stop-color="#00a0e7" stop-opacity="1"></stop>
            <stop _ngcontent-rkl-c19="" offset="1" stop-color="#00a5ed" stop-opacity="1"></stop>
          </linearGradient>
          <path _ngcontent-rkl-c19="" id="Trac_1112_umn"
                d="M 915.5758056640625 2284.14208984375 C 908.275634765625 2284.14208984375 902.35791015625 2289.708251953125 902.35791015625 2296.57470703125 C 902.35791015625 2299.5927734375 903.503662109375 2302.357421875 905.4052734375 2304.510986328125 C 905.4742431640625 2304.589111328125 905.4786376953125 2304.704345703125 905.414794921875 2304.78662109375 L 902.407470703125 2308.6572265625 C 902.296630859375 2308.799560546875 902.3983154296875 2309.007568359375 902.57861328125 2309.007568359375 L 909.2991943359375 2309.007568359375 C 909.3656005859375 2309.007568359375 909.4283447265625 2308.976806640625 909.469482421875 2308.9248046875 L 910.2401123046875 2307.949462890625 L 912.7122802734375 2304.818115234375 C 912.79833984375 2304.709228515625 912.7598876953125 2304.55126953125 912.6357421875 2304.48974609375 C 910.9837646484375 2303.664306640625 909.61572265625 2302.196533203125 908.75927734375 2300.48193359375 C 908.1419677734375 2299.24609375 907.7894287109375 2297.882080078125 907.7894287109375 2296.5380859375 C 907.7894287109375 2292.30419921875 911.2755126953125 2288.871337890625 915.5758056640625 2288.871337890625 C 919.8760986328125 2288.871337890625 923.36181640625 2292.30419921875 923.36181640625 2296.5380859375 C 923.36181640625 2297.949462890625 922.972900390625 2299.382080078125 922.296875 2300.665771484375 C 921.406005859375 2302.357666015625 920.014404296875 2303.788818359375 918.347900390625 2304.56787109375 C 918.2198486328125 2304.628173828125 918.17822265625 2304.789306640625 918.265869140625 2304.900390625 L 920.7330322265625 2308.02490234375 L 921.4439697265625 2308.9248046875 C 921.4849853515625 2308.976806640625 921.547607421875 2309.007568359375 921.6141357421875 2309.007568359375 L 928.33447265625 2309.007568359375 C 928.5147705078125 2309.007568359375 928.616455078125 2308.799560546875 928.5057373046875 2308.6572265625 L 925.6090087890625 2304.928955078125 C 925.5443115234375 2304.845703125 925.5499267578125 2304.728759765625 925.620849609375 2304.65087890625 C 927.597412109375 2302.478271484375 928.793701171875 2299.658447265625 928.793701171875 2296.57470703125 C 928.793701171875 2289.708251953125 922.875732421875 2284.14208984375 915.5758056640625 2284.14208984375 Z"></path>
        </svg>
        <svg _ngcontent-dkb-c19="" viewBox="951.628 2426.568 11.411 7.782" class="Trac_1113n">
          <path _ngcontent-dkb-c19="" id="Trac_1113"
                d="M 962.4252319335938 2433.2568359375 L 961.6259155273438 2432.181640625 L 957.5144653320313 2426.6494140625 C 957.4342651367188 2426.54150390625 957.2728881835938 2426.541259765625 957.1921997070313 2426.648681640625 L 953.0552368164063 2432.17529296875 L 952.2456665039063 2433.2568359375 L 952.1973266601563 2433.321533203125 L 951.6686401367188 2434.028076171875 C 951.5501098632813 2434.18603515625 951.7070922851563 2434.402587890625 951.8941040039063 2434.3388671875 L 953.2776489257813 2433.86962890625 L 955.0813598632813 2433.2568359375 L 955.4174194335938 2433.14306640625 L 957.2887573242188 2432.507568359375 C 957.3308715820313 2432.493408203125 957.3765258789063 2432.493408203125 957.4187622070313 2432.507568359375 L 959.2752075195313 2433.142822265625 L 959.6098022460938 2433.2568359375 L 961.4170532226563 2433.875 L 962.7716674804688 2434.338134765625 C 962.9585571289063 2434.40234375 963.1157836914063 2434.18603515625 962.9979858398438 2434.02783203125 L 962.4846801757813 2433.337158203125 L 962.4252319335938 2433.2568359375 Z"></path>
        </svg>

      </div>
    </div>
    <div class="row " [ngClass]="{'collapse_list':collapsed}">
      <div class="col list-elements scrollbar" >
        <ul >
          <ng-container>
            <div id="accordian">
              <ul style="margin-top: 58px">
                <li [ngClass]="{'inactive_menu': r.isNotActiveMenu,'active_menu':!r.isNotActiveMenu,'inactive_menu_slide':collapsed}"
                    *ngFor="let r of routes;let index=index" style="display: block;padding-left: 9px;margin-left: 15px;"
                    class="list-element"
                    [routerLink]="r.path.trim()?.toString() !='' ? [r.path.trim()?.toString()] : [] ">
                  <input type="radio" class="icondown" (click)="isActiveMenu(r.menu_id,r.icon)" name="radioicon"  id="{{r.menu_id}}">
                  <label for="{{r.menu_id}}"  class="row" style="padding: 13px 0;cursor: pointer;" (click)="onchangeIcon(r.menu_id)">
                    <div class="col-4 icon-style " [ngClass]="{
                      'icon-style-not-active': r.isNotActiveMenu}" >
                      <fa-icon [icon]="fa[r.icon]"></fa-icon>
                    </div>
                    <div class="col-6 Tableau_de_Bord_t" [ngClass]="{
                      'Tableau_de_Bord_t_not_active': r.isNotActiveMenu,'collapse_label':collapsed}">
                      {{r.title}}
                    </div>
                    <div *ngIf="r.child.length >0" class="col">
                      <div class="col-2 faIcon" [ngClass]="{
                        'faIconNotActive': r.isNotActiveMenu}">
                        <i class="fa fa-angle-down" [ngClass]="{
                          'rotate': id==r.menu_id && active , 'rotateup':id==r.menu_id && active }" ></i>
                      </div>
                    </div>
                  </label>
                  <ng-container *ngIf="r.child.length >0">
                    <ng-container *ngTemplateOutlet="list;context:{'routes': r.child}"></ng-container>
                  </ng-container>
                </li>
              </ul>
            </div>
          </ng-container>
        </ul>
      </div>
    </div>

  </div>
</div>

<ng-template #list let-routes="routes" >
  <ul class="sub_menu_list ">
    <li class="list-element" style="display: block" *ngFor="let r of routes;let index=index"
        [routerLink]="r.path.trim()?.toString() !='' ? [r.path.trim()?.toString()] : [] ">
      <input type="checkbox"  class="labbel" name="popular" id="{{r.menu_id}}">
      <label for="{{r.menu_id}}"   class="row" style="padding: 18px 0; cursor: pointer;" (click)="onchangeIcon(r.menu_id)">
      <div class="col icon-style" [ngClass]="{
        'icon-style-not-active': !r.isNotActiveMenu}">
        <fa-icon  [icon]="fa[r.icon]"></fa-icon>
      </div>
      <div class="col Tableau_de_Bord_t" [ngClass]="{
        'Tableau_de_Bord_t_not_active text-wrap': !r.isNotActiveMenu,'collapse_label':collapsed}">
          {{r.title}}
      </div>
      <div *ngIf="r.child.length >0" class="col" style="max-width: 15px">
        <div class="col faIcon" [ngClass]="{'
        faIconNotActive': !r.isNotActiveMenu}">
            <i class="fa fa-angle-down" [ngClass]="{
              'rotate': id==r.menu_id}"></i>
        </div>
      </div>
      </label>
      <ng-container *ngIf="r.child.length >0">
        <ng-container *ngTemplateOutlet="list;context:{'routes': r.child}"></ng-container>
      </ng-container>
    </li>
  </ul>
</ng-template>
